import React from "react";

/**
 * Function component for rendering the bottom action bar of the filter modal.
 *
 * @param {function} applyFunc - Function to be called when the apply button is clicked
 * @param {function} resetFunc - Function to be called when the reset button is clicked
 * @return {JSX} JSX element representing the bottom action bar of the filter modal
 */
const FilterModalBottomAction = ({ applyFunc, resetFunc }) => {
  return (
    <div className="FilterModalBottomAction_Wrapepr">
      <div className="flex justify-end gap-5">
        <button
          type="button"
          className="transition-linear flex h-[40px] w-[120px] items-center justify-center rounded-lg border border-primary bg-primary text-white hover:bg-none hover:text-primary"
          onClick={() => {
            applyFunc();
          }}
        >
          Apply
        </button>
        <button
          type="button"
          className="transition-linear flex h-[40px] w-[120px] items-center justify-center rounded-lg border border-primary bg-none text-primary hover:bg-primary hover:text-white"
          onClick={() => {
            resetFunc();
          }}
        >
          Reset
        </button>
      </div>
    </div>
  );
};

export default FilterModalBottomAction;
